import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Wifi, WifiOff, DollarSign } from 'lucide-react';

const ConnectionStatus = ({ connected, accountType, balance, onSwitchAccount }) => {
  return (
    <div className="connection-status" data-testid="connection-status-component">
      <div className="status-badge">
        {connected ? (
          <Badge variant="default" className="success-badge" data-testid="connected-badge">
            <Wifi className="w-3 h-3 mr-1" />
            Connected
          </Badge>
        ) : (
          <Badge variant="destructive" data-testid="disconnected-badge">
            <WifiOff className="w-3 h-3 mr-1" />
            Disconnected
          </Badge>
        )}
      </div>

      {connected && (
        <>
          <div className="account-selector">
            <Select value={accountType} onValueChange={onSwitchAccount}>
              <SelectTrigger className="w-32" data-testid="account-type-selector">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="demo" data-testid="account-demo-option">Demo</SelectItem>
                <SelectItem value="live" data-testid="account-live-option">Live</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="balance-display" data-testid="balance-display">
            <DollarSign className="w-4 h-4" />
            <span className="balance-amount" data-testid="balance-amount">${balance.toFixed(2)}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default ConnectionStatus;
